/**
 * User-facing wording for the artifacts surface.
 *
 * "Artifacts" deliberately matches an existing product concept: the desktop app
 * already ships a workspace-artifacts pill in its composer over the files an
 * agent produced. Kept in one place anyway so any future wording change stays a
 * single edit — components, stories and tests all read these constants.
 */

/** Heading of the artifacts panel and the accessible name of its region. */
export const ARTIFACTS_LABEL = 'Artifacts'

export const ARTIFACTS_EXPAND_LABEL = `Show ${ARTIFACTS_LABEL.toLowerCase()}`
export const ARTIFACTS_COLLAPSE_LABEL = `Hide ${ARTIFACTS_LABEL.toLowerCase()}`
